<template>
  <div class="payment-detail">
    <div class="form-wrapper">
      <el-form :inline="true" label-width="120px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="项目部">
              <el-input :value="detailData.deptName" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="项目名称">
              <el-input :value="detailData.projectName" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="付款申请日期">
              <el-input :value="detailData.payApplyDate" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="付款明细日期">
              <el-input :value="detailData.payDetailDate" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div
      class="table-wrapper"
    >
      <el-table :data="payDetailItemVOList" border style="width: 100%;">
        <el-table-column
          type="index"
          label="序号"
          width="100"
          fixed
        ></el-table-column>
        <el-table-column
          prop="vendorName"
          label="收款单位名称"
          width="200"
        ></el-table-column>
        <el-table-column
          prop="bankName"
          label="开户行"
          width="200"
        ></el-table-column>
        <el-table-column
          prop="cardNumber"
          label="账户"
          width="200"
        ></el-table-column>
        <el-table-column label="本次审批付款额" width="200">
          <template slot-scope="scope">
            <div>{{ formatMoneyNumber(scope.row.payAmount) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="支付方式">
          <el-table-column label="转账支票" width="100">
            <template slot-scope="scope">
              <div>{{ formatMoneyNumber(scope.row.checkAmount) }}</div>
            </template>
          </el-table-column>
          <el-table-column label="网银" width="100">
            <template slot-scope="scope">
              <div>{{ formatMoneyNumber(scope.row.ebankAmount) }}</div>
            </template>
          </el-table-column>
          <el-table-column label="商业承兑(纸质/电子)" width="100">
            <template slot-scope="scope">
              <div>
                {{ formatMoneyNumber(scope.row.tradeAcceptanceAmount) }}
              </div>
            </template></el-table-column
          >
          <el-table-column label="银行承兑(纸质/电子)" width="100">
            <template slot-scope="scope">
              <div>{{ formatMoneyNumber(scope.row.bankAcceptanceAmount) }}</div>
            </template></el-table-column
          >
        </el-table-column>
        <el-table-column label="当前已付款额">
          <template slot-scope="scope">
            <div>{{ formatMoneyNumber(scope.row.alreadyPayAmount) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="remark" width="200">
        </el-table-column>
      </el-table>
    </div>
    <div class="footer">
      <p>
        <span>最近操作用户：</span>
        <span>{{ detailData.operatorName }}</span>
      </p>
      <p>
        <span>最近操作日期：</span>
        <span>{{ detailData.updateTime }}</span>
      </p>
    </div>
    <div style="text-align: center;">
      <el-button type="primary" @click.stop="exportData">导出</el-button>
      <el-button type="info" @click.stop="closePage">关闭</el-button>
    </div>
  </div>
</template>

<script>
/**
 * 付款明细，查看详情
 */
import {
  getPaymentDetail,
  payDetailExportApi
} from "../../services/financeService";
import Constants from "../../utils/consts";
import { formatMoney } from "./utils";
export default {
  data() {
    return {
      id: undefined,
      detailData: {},
      payDetailItemVOList: []
    };
  },
  methods: {
    log(params) {
      console.log("--log", params);
    },
    formatMoneyNumber: formatMoney,
    onActive() {
      let params = this.tabRouteParam || {};
      if (params.id) {
        this.id = params.id;
      }
      // this.id = 1; //test
      if (!this.id) {
        return;
      }
      this.getDetail();
    },
    getDetail() {
      getPaymentDetail({ id: this.id })
        .then(res => {
          if (res.code == Constants.Code_OK) {
            this.detailData = res.data || {};
            this.payDetailItemVOList =
              this.detailData.payDetailItemVOList || [];
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch(error => {
          this.$alert(error instanceof Error ? error.message : error, "提示");
        });
    },
    closePage() {
      this.bus.$emit("tabClose", "paymentDetail");
      this.bus.$emit("navMenuChange", {
        routeId: "paymentList"
      });
    },
    /**
     * 导出付款明细详情
     */
    exportData() {
      if (this.id) {
        payDetailExportApi({
          exportIds: this.id
        })
          .then(res => {
            if (res.code == Constants.Code_OK) {
              let url = res.data;
              const a = document.createElement("a");
              a.href = url;
              a.download = "付款明细";
              a.click();
            } else {
              this.$alert(res.msg, "提示");
            }
          })
          .catch(error => {
            this.$alert(error.message, "提示");
          });
      } else {
        this.$alert("操作失败", "提示");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
// @import "./table.scss"

.payment-detail {
  background: white;
  padding: 16px;
}

/deep/.el-form-item {
  width: 100% !important;
}

/deep/.el-form-item__content {
  width: calc(100% - 120px) !important;
}

.footer {
  margin-top: 16px;
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
